import { BusinessClock } from '../../core/time/business-clock.service';
import { clockView } from '../../core/time/business-time';
import { businessDayjs } from '../../core/time/business-calendar';
import { jstCalendarPlugin, calendarNow } from '../../core/time/business-calendar';
import { Component, OnInit, AfterViewInit, NgZone, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { NgStyle } from '@angular/common';
import { PageTitleService } from '../../core/services/page-title.service';
import { StudioService } from '../../core/services/studio.service';
import { PtReservationScheduleService } from '../../core/services/pt-reservation-schedule.service';
import { PtReservationMaskService } from '../../core/services/pt-reservation-mask.service';
import { StudioSelectionService } from '../../core/services/studio-selection.service';
import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import {
  JAPANESE_HOLIDAY_SOURCE_ID,
  loadJapaneseHolidayEvents,
} from '../../shared/utils/japanese-holiday-calendar';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import 'dayjs/locale/ja';
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.locale('ja');

const SESSION_KEY = 'pt_reservation_select_studio_id';
const DAY_NAMES = ['日', '月', '火', '水', '木', '金', '土'];

@Component({
    selector: 'app-pt-reservation-schedule',
    imports: [RouterLink, FormsModule, NgStyle],
    template: `
<div class="animated fadeIn">
  <div class="row sfapp-container">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <span><i class="fa s-icon-list"></i> 受付時間</span>
        </div>
        <div class="card-body">
          <div style="height: 1px"></div>
          <form novalidate name="myForm">
            <div class="row">
              <div class="col-md-4">
                <div class="form-group row">
                  <div class="col-md-12">
                    <label class="col-form-label" for="studio_name">店舗</label>
                    <select class="form-control" id="studio_name" name="studio_name"
                      [(ngModel)]="selectedStudio" (ngModelChange)="onStudioChange()">
                      <option [ngValue]="null">-- 選択してください --</option>
                      @for (s of studios; track s.id) {
                        <option [ngValue]="s">{{s.name}}</option>
                      }
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <hr>
        </div>
        <div class="card-body">
          <div class="row form-group">
            <div class="col-md-12">
              <button class="form-group btn btn-primary text-white" type="button" [disabled]="!selectedStudio" (click)="openNewSchedule()">
                <span class="material-symbols-outlined align-bottom mr-1">edit</span>&nbsp;新規作成
              </button>
              <button class="form-group btn btn-danger text-white" type="button" [disabled]="!selectedStudio" (click)="openRangeDelete()">
                <span class="material-symbols-outlined align-bottom mr-1">delete</span>&nbsp;範囲指定削除
              </button>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div [ngStyle]="{display: selectedStudio ? 'block' : 'none'}" id="calendar"></div>
        </div>
      </div>
    </div>
  </div>
</div>
@if (showScheduleModal && selectedStudio) {
  <div class="modal-backdrop fade show"></div>
  <div class="modal fade show d-block" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{scheduleFormData.id ? '編集' : '新規作成'}}</h5>
          <button type="button" class="close" (click)="closeScheduleModal()"><span aria-hidden="true">&times;</span></button>
        </div>
        <form novalidate #scheduleForm="ngForm">
          <div class="modal-body">
            @if (scheduleFormData.id) {
              <div class="form-group row">
                <label class="col-md-4 col-form-label">設定日</label>
                <div class="col-md-8"><label class="col-form-label">{{scheduleFormData.targetTimeStr}}</label></div>
              </div>
            } @else {
              <div class="form-group row">
                <label class="col-md-4 col-form-label">設定開始日</label>
                <div class="col-md-8">
                  <select class="form-control" name="startDay" [(ngModel)]="scheduleFormData.startDay" required>
                    <option [ngValue]="null">-- 選択してください --</option>
                    @for (d of scheduleDates; track d.id) { <option [ngValue]="d.id">{{d.name}}</option> }
                  </select>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-md-4 col-form-label">設定終了日</label>
                <div class="col-md-8">
                  <select class="form-control" name="endDay" [(ngModel)]="scheduleFormData.endDay" required>
                    <option [ngValue]="null">-- 選択してください --</option>
                    @for (d of filteredEndDates(); track d.id) { <option [ngValue]="d.id">{{d.name}}</option> }
                  </select>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-md-4 col-form-label">設定曜日</label>
                <div class="col-md-8">
                  <select class="form-control" name="weekDay" [(ngModel)]="scheduleFormData.weekDay">
                    <option [ngValue]="null">指定なし</option>
                    @for (d of dayNames; track $index) { <option [ngValue]="$index">{{d}}曜日</option> }
                  </select>
                </div>
              </div>
            }
            <div class="form-group row">
              <label class="col-md-4 col-form-label">受付開始</label>
              <div class="col-md-8">
                <select class="form-control" name="startTime" [(ngModel)]="scheduleFormData.startTime" required>
                  <option [ngValue]="null">-- 選択してください --</option>
                  @for (t of scheduleTimes; track t) { <option [ngValue]="t">{{t}}</option> }
                </select>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-md-4 col-form-label">最終受付</label>
              <div class="col-md-8">
                <select class="form-control" name="endTime" [(ngModel)]="scheduleFormData.endTime" required>
                  <option [ngValue]="null">-- 選択してください --</option>
                  @for (t of filteredEndTimes(); track t) { <option [ngValue]="t">{{t}}</option> }
                </select>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-md-4 col-form-label">受付停止</label>
              <div class="col-md-8">
                <select class="form-control" name="stopTime" [(ngModel)]="scheduleFormData.stopTime">
                  <option [ngValue]="null">-- 選択してください --</option>
                  @for (t of filteredStopTimes(); track t) { <option [ngValue]="t">{{t}}</option> }
                </select>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-md-4 col-form-label">受付再開</label>
              <div class="col-md-8">
                <select class="form-control" name="restartTime" [(ngModel)]="scheduleFormData.restartTime">
                  <option [ngValue]="null">-- 選択してください --</option>
                  @for (t of filteredRestartTimes(); track t) { <option [ngValue]="t">{{t}}</option> }
                </select>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-md-4 col-form-label">受付人数(合計)</label>
              <div class="col-md-8">
                <select class="form-control" name="allNum" [(ngModel)]="scheduleFormData.allNum" required>
                  <option [ngValue]="null">-- 選択してください --</option>
                  @for (n of positiveScheduleNumbers; track n) { <option [ngValue]="n">{{n}}</option> }
                </select>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-md-4 col-form-label">受付人数(PT)</label>
              <div class="col-md-8">
                <select class="form-control" name="ptNum" [(ngModel)]="scheduleFormData.ptNum" required>
                  <option [ngValue]="null">-- 選択してください --</option>
                  @for (n of filteredPtNumbers(); track n) { <option [ngValue]="n">{{n}}</option> }
                </select>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn bg-close text-white" type="button" (click)="closeScheduleModal()">閉じる</button>
            @if (scheduleFormData.id) {
              <button class="btn btn-danger" type="button" (click)="removeSelectedSchedule()">削除</button>
            }
            <button class="btn btn-success" type="button" [disabled]="scheduleForm.invalid || !isScheduleFormValid()" (click)="saveSchedule()">保存</button>
          </div>
        </form>
      </div>
    </div>
  </div>
}
@if (showRangeDeleteModal && selectedStudio) {
  <div class="modal-backdrop fade show"></div>
  <div class="modal fade show d-block" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">範囲指定削除</h5>
          <button type="button" class="close" (click)="closeRangeDelete()"><span aria-hidden="true">&times;</span></button>
        </div>
        <form novalidate #rangeDeleteForm="ngForm">
          <div class="modal-body">
            <div class="form-group row">
              <label class="col-md-4 col-form-label">範囲指定削除開始日</label>
              <div class="col-md-8"><input type="date" class="form-control" name="rangeStart" [(ngModel)]="rangeStart" required></div>
            </div>
            <div class="form-group row">
              <label class="col-md-4 col-form-label">範囲指定削除終了日</label>
              <div class="col-md-8"><input type="date" class="form-control" name="rangeEnd" [(ngModel)]="rangeEnd" [min]="rangeStart" required></div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn bg-close text-white" type="button" (click)="closeRangeDelete()">閉じる</button>
            <button class="btn btn-danger" type="button" [disabled]="rangeDeleteForm.invalid || rangeEnd < rangeStart" (click)="deleteRange()">削除</button>
          </div>
        </form>
      </div>
    </div>
  </div>
}
  `
})
export class PtReservationScheduleComponent implements OnInit, AfterViewInit {
  private readonly businessClock = inject(BusinessClock);
  private readonly clockContext = clockView(true);

  private pageTitleService = inject(PageTitleService);
  private studioService = inject(StudioService);
  private ptScheduleService = inject(PtReservationScheduleService);
  private ptMaskService = inject(PtReservationMaskService);
  private studioSelection = inject(StudioSelectionService);
  private zone = inject(NgZone);

  studios: any[] = [];
  selectedStudio: any = null;
  items: any[] = [];
  searching = false;
  showScheduleModal = false;
  showRangeDeleteModal = false;
  scheduleFormData: any = {};
  rangeStart = '';
  rangeEnd = '';
  readonly dayNames = DAY_NAMES;
  readonly scheduleDates = this.getScheduleDates();
  readonly scheduleTimes = this.getScheduleTimes();
  readonly scheduleNumbers = Array.from({ length: 11 }, (_, index) => index);
  readonly positiveScheduleNumbers = this.scheduleNumbers.filter(value => value > 0);
  private calendar: Calendar | null = null;
  private holidayLoadId = 0;
  private viewInitialized = false;
  private restoredStudioLoaded = false;

  dayName(d: number): string { return `${DAY_NAMES[d] ?? d}曜日`; }

  async ngOnInit(): Promise<void> {
    this.pageTitleService.set('予約管理', 'fa fa-calendar');
    this.studios = await this.studioService.list('all') ?? [];
    const restored = this.studioSelection.restore(this.studios, SESSION_KEY);
    if (restored) {
      this.selectedStudio = restored;
    }
    await this.loadRestoredStudio();
  }

  ngAfterViewInit(): void {
    this.viewInitialized = true;
    this.initCalendar();
    void this.loadRestoredStudio();
  }

  private initCalendar(): void {
    const calendarEl = document.getElementById('calendar');
    if (!calendarEl) return;
    this.calendar = new Calendar(calendarEl, {
      plugins: [jstCalendarPlugin, dayGridPlugin, timeGridPlugin, interactionPlugin],
      timeZone: 'Asia/Tokyo', now: calendarNow,
      locale: 'ja',
      contentHeight: 'auto',
      initialView: 'dayGridMonth',
      slotEventOverlap: false,
      dayMaxEventRows: 3,
      eventDisplay: 'block',
      titleFormat: { year: 'numeric', month: '2-digit', day: '2-digit', weekday: 'short' },
      displayEventEnd: true,
      eventTimeFormat: { hour: '2-digit', minute: '2-digit', hour12: false },
      eventMinHeight: 15,
      nowIndicator: true,
      allDaySlot: false,
      headerToolbar: { end: 'today prev,next' },
      datesSet: (info: any) => {
        void this.refreshHolidayEvents(info.start, info.end);
      },
      eventDataTransform: (eventData: any) => {
        if (eventData?.extendedProps?.type === 'holiday') return eventData;
        if (eventData?.url) return eventData;
        return {
          ...eventData,
          start: eventData.startedAt,
          end: eventData.endedAt,
          title: eventData.supportedNum
            ? `合計: ${eventData.supportedNum} PT: ${eventData.supportedPtNum}`
            : '受付停止',
        };
      },
      eventDidMount: (info: any) => {
        if (info.event?._def?.extendedProps?.type === 'holiday') return;
        if (info.event._def?.url) return;
        const titleEl = info.el.querySelector('.fc-event-title');
        if (titleEl) titleEl.style.fontSize = '20px';
        if (info.event._def.extendedProps.isMask) {
          info.el.style.borderColor = '#f86c6b';
          info.el.style.backgroundColor = '#f86c6b';
        }
      },
      eventContent: (info: any) => {
        if (info.event?._def?.extendedProps?.type === 'holiday') {
          const title = document.createElement('div');
          title.className = 'fc-event-title';
          title.textContent = info.event.title;
          return { domNodes: [title] };
        }
        if (info.event?._def?.url) return;
        const mask = info.event?._def?.extendedProps?.reservationScheduleMask;
        const maskStart = mask ? businessDayjs(mask.startedAt).tz('Asia/Tokyo').format('HH:mm') : '';
        const maskEnd = mask ? businessDayjs(mask.endedAt).tz('Asia/Tokyo').format('HH:mm') : '';
        return {
          html: `<div class="p-1">
            <span>${info.timeText}</span><br>
            <span style="font-size: 1rem">${info.event.title}</span>
            ${mask ? `<div class="p-1 bg-danger" style="border-radius: 3px">
              <span>${maskStart} - ${maskEnd}</span><br>
              <span style="font-size: 1rem">受付停止</span>
            </div>` : ''}
          </div>`,
        };
      },
      eventClick: (info: any) => {
        if (info.event?._def?.extendedProps?.type === 'holiday') return;
        if (info.event?._def?.url) return;
        this.zone.run(() => this.openEditSchedule(info.event));
      },
    });
    this.calendar.render();
  }

  async onStudioChange(): Promise<void> {
    this.items = [];
    if (!this.selectedStudio) {
      this.studioSelection.clear(SESSION_KEY);
      this.restoredStudioLoaded = false;
      this.refreshCalendarEvents();
      return;
    }
    this.studioSelection.save(this.selectedStudio, SESSION_KEY);
    await this.load();
  }

  async load(): Promise<void> {
    if (!this.selectedStudio) return;
    this.searching = true;
    try {
      this.items = await this.ptScheduleService.getAll(this.selectedStudio.id) ?? [];
      this.refreshCalendarEvents();
    } finally {
      this.searching = false;
    }
  }

  private async loadRestoredStudio(): Promise<void> {
    if (this.restoredStudioLoaded || !this.viewInitialized || !this.calendar || !this.selectedStudio) return;
    this.restoredStudioLoaded = true;
    await this.load();
  }

  private refreshCalendarEvents(): void {
    if (!this.calendar) return;
    this.calendar.batchRendering(() => {
      this.calendar?.removeAllEventSources();
      if (this.selectedStudio && this.items.length > 0) {
        this.calendar?.addEventSource(this.items);
      }
    });
    void this.refreshHolidayEvents(this.calendar.view.activeStart, this.calendar.view.activeEnd);
    setTimeout(() => {
      this.calendar?.render();
      this.calendar?.updateSize();
    }, 0);
  }

  private async refreshHolidayEvents(start: Date, end: Date): Promise<void> {
    if (!this.calendar) return;
    const loadId = ++this.holidayLoadId;
    try {
      const events = await loadJapaneseHolidayEvents(start, end);
      if (!this.calendar || loadId !== this.holidayLoadId) return;
      this.calendar.getEventSourceById(JAPANESE_HOLIDAY_SOURCE_ID)?.remove();
      this.calendar.addEventSource({ id: JAPANESE_HOLIDAY_SOURCE_ID, events });
    } catch (error) {
      console.warn('日本祝日カレンダーの取得に失敗しました。', error);
    }
  }

  openNewSchedule(): void {
    this.scheduleFormData = {
      startDay: null, endDay: null, weekDay: null,
      startTime: null, endTime: null, stopTime: null, restartTime: null,
      allNum: null, ptNum: null,
    };
    this.showScheduleModal = true;
  }

  openEditSchedule(event: any): void {
    const values = event?._def?.extendedProps ?? {};
    const mask = values.reservationScheduleMask;
    const reservationDate = values.reservationDate;
    this.scheduleFormData = {
      id: event.id,
      studioId: values.studioId,
      startDay: reservationDate,
      endDay: reservationDate,
      startTime: businessDayjs(values.startedAt).format('HH:mm'),
      endTime: businessDayjs(values.endedAt).format('HH:mm'),
      stopTime: mask ? businessDayjs(mask.startedAt).format('HH:mm') : null,
      restartTime: mask ? businessDayjs(mask.endedAt).format('HH:mm') : null,
      allNum: values.supportedNum,
      ptNum: values.supportedPtNum,
      targetTimeStr: businessDayjs(reservationDate).format('YYYY/MM/DD(ddd)'),
      isMask: values.isMask,
    };
    this.showScheduleModal = true;
  }

  closeScheduleModal(): void {
    this.showScheduleModal = false;
    this.scheduleFormData = {};
  }

  openRangeDelete(): void {
    this.rangeStart = '';
    this.rangeEnd = '';
    this.showRangeDeleteModal = true;
  }

  closeRangeDelete(): void {
    this.showRangeDeleteModal = false;
  }

  filteredEndDates(): { id: string; name: string }[] {
    if (!this.scheduleFormData.startDay) return this.scheduleDates;
    return this.scheduleDates.filter(date => date.id >= this.scheduleFormData.startDay);
  }

  filteredEndTimes(): string[] {
    if (!this.scheduleFormData.startTime) return this.scheduleTimes;
    return this.scheduleTimes.filter(time => time > this.scheduleFormData.startTime);
  }

  filteredStopTimes(): string[] {
    const { startTime, endTime } = this.scheduleFormData;
    return this.scheduleTimes.filter(time => (!startTime || time > startTime) && (!endTime || time < endTime));
  }

  filteredRestartTimes(): string[] {
    const { stopTime, endTime } = this.scheduleFormData;
    return this.scheduleTimes.filter(time => (!stopTime || time > stopTime) && (!endTime || time <= endTime));
  }

  filteredPtNumbers(): number[] {
    if (this.scheduleFormData.allNum == null) return this.scheduleNumbers;
    return this.scheduleNumbers.filter(value => value <= this.scheduleFormData.allNum);
  }

  isScheduleFormValid(): boolean {
    const data = this.scheduleFormData;
    if (!data.startTime || !data.endTime || data.endTime <= data.startTime) return false;
    if (data.stopTime && (!data.restartTime || data.stopTime <= data.startTime || data.stopTime >= data.endTime)) return false;
    if (data.restartTime && (!data.stopTime || data.restartTime <= data.stopTime || data.restartTime > data.endTime)) return false;
    if (data.allNum == null || data.ptNum == null || data.ptNum > data.allNum) return false;
    return Boolean(data.id || (data.startDay && data.endDay && data.endDay >= data.startDay));
  }

  async saveSchedule(): Promise<void> {
    if (!await this.businessClock.confirm(this.clockContext)) return;
    if (!this.selectedStudio || !this.isScheduleFormValid()) return;
    // 旧版 pt-reservation-schedule.js:127-139 の select_schedule と同じ項目で送る（isMask は削除先の判定用で送信しない）
    const { isMask, ...formData } = this.scheduleFormData;
    const json = { ...formData, studioId: this.selectedStudio.id };
    if (json.id) await this.ptScheduleService.update(json);
    else await this.ptScheduleService.create(json);
    this.closeScheduleModal();
    await this.load();
  }

  async deleteRange(): Promise<void> {
    if (!await this.businessClock.confirm(this.clockContext)) return;
    if (!this.rangeStart || !this.rangeEnd || !this.selectedStudio) return;
    const start = businessDayjs(this.rangeStart).tz('Asia/Tokyo').subtract(1, 'day');
    const end = businessDayjs(this.rangeEnd).tz('Asia/Tokyo').add(1, 'day');
    const ids = this.items
      .filter((item: any) => {
        if (!item.reservationDate) return false;
        const d = businessDayjs(item.reservationDate).tz('Asia/Tokyo');
        return d.isAfter(start, 'day') && d.isBefore(end, 'day');
      })
      .map((item: any) => item.id);
    if (ids.length > 0) {
      await this.ptScheduleService.remove({ id: ids });
      await this.load();
    }
    this.closeRangeDelete();
  }

  async removeSelectedSchedule(): Promise<void> {
    if (!await this.businessClock.confirm(this.clockContext)) return;
    if (!this.scheduleFormData?.id) return;
    await this.removeSchedule(this.scheduleFormData);
    this.closeScheduleModal();
  }

  async removeSchedule(item: any): Promise<void> {
    if (!await this.businessClock.confirm(this.clockContext)) return;
    if (item.isMask) {
      await this.ptMaskService.remove({ id: item.id });
    } else {
      await this.ptScheduleService.remove({ id: item.id });
    }
    await this.load();
  }

  private getScheduleDates(): { id: string; name: string }[] {
    const today = businessDayjs().tz('Asia/Tokyo').startOf('day');
    const nextMonthEnd = today.add(1, 'month').endOf('month');
    const length = nextMonthEnd.diff(today, 'day') + 1;
    return Array.from({ length }, (_, index) => {
      const date = today.add(index, 'day');
      return { id: date.format('YYYY-MM-DD'), name: date.format('YYYY/MM/DD(ddd)') };
    });
  }

  private getScheduleTimes(): string[] {
    const values: string[] = [];
    for (let minutes = 9 * 60; minutes <= 21 * 60; minutes += 15) {
      values.push(`${String(Math.floor(minutes / 60)).padStart(2, '0')}:${String(minutes % 60).padStart(2, '0')}`);
    }
    return values;
  }
}
